__webpack_require__.p = "https://admin-panel-stage.winlocal.com/";